export function postClosingOccupancyAgreement2026() {
return [   // Release 2025-12-19 15:48:33
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 231.28,
   left: 464.64,
   width: 116.04,
   height: 13.80
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 304.36,
   left: 44.88,
   width: 500.04,
   height: 13.80
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 319.0,
   left: 61.8,
   width: 485.04,
   height: 13.8
}
,
{
   page: 0,
   name: "Address County", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 334.12,
   left: 396.96,
   width: 180.00,
   height: 13.80
}
,
{
   page: 0,
   name: "Address Legal Description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 362.62,
   left: 39.2729,
   width: 549.9291,
   height: 211.165
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 573.96,
   left: 87.0546,
   width: 434.8804,
   height: 13.80
}
,
{
   page: 0,
   name: "Date Contract Date", 
   fontSize: 9,
   type: "date",
   top: 599.52,
   left: 460.68,
   width: 119.88,
   height: 13.80
}
,
{
   page: 0,
   name: "Date POCOA", 
   fontSize: 9,
   type: "date",
   top: 665.76,
   left: 455.52,
   width: 125.04,
   height: 13.80
}
,
{
   page: 0,
   name: "Time POCOA", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 680.4,
   left: 130.92,
   width: 135.00,
   height: 10.68
}
,
{
   page: 1,
   name: "Amount Rent", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 301.2,
   left: 204.6,
   width: 234.96,
   height: 12.36
}
,
{
   page: 1,
   name: "Radiobutton RentProrated Will", 
   isText: false,
   type: "checkbox",
   top: 318.765,
   left: 435.929,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Radiobutton RentProrated Will Not", 
   isText: false,
   type: "checkbox",
   top: 318.111,
   left: 479.129,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Radiobuttton WaterAndSewerPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 432.002,
   left: 458.838,
   width: 10.080,
   height: 10.735
}
,
{
   page: 1,
   name: "Radiobuttton WaterAndSewerPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 431.347,
   left: 513.166,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Radiobuttton ElectricAndGasPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 454.257,
   left: 478.475,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Radiobuttton ElectricAndGasPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 454.257,
   left: 533.457,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Radiobuttton SellersRenterInsurance Will", 
   isText: false,
   type: "checkbox",
   top: 499.42,
   left: 258.547,
   width: 10.080,
   height: 10.735
}
,
{
   page: 1,
   name: "Radiobuttton SellersRenterInsurance Will Not", 
   isText: false,
   type: "checkbox",
   top: 500.075,
   left: 303.056,
   width: 10.080,
   height: 10.080
}
,
{
   page: 1,
   name: "Amount Security Deposit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 618.415,
   left: 189.48,
   width: 120.00,
   height: 12.360
}
,
{
   page: 2,
   name: "Buyer 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 225.72,
   left: 108.36,
   width: 470.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Buyer 1 Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 263.76,
   left: 112.56,
   width: 465.00,
   height: 14.04
}
,
{
   page: 2,
   name: "Buyer 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 278.76,
   left: 112.56,
   width: 170.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Buyer 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 278.76,
   left: 407.04,
   width: 170.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Buyer 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 293.76,
   left: 112.56,
   width: 465.00,
   height: 14.04
}
,
{
   page: 2,
   name: "Buyer 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 316.68,
   left: 108.36,
   width: 470.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Buyer 2 Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 354.72,
   left: 112.56,
   width: 465.00,
   height: 14.04
}
,
{
   page: 2,
   name: "Buyer 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 369.48,
   left: 112.56,
   width: 170.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Buyer 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 369.48,
   left: 407.04,
   width: 170.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Buyer 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 384.48,
   left: 112.56,
   width: 465.00,
   height: 14.04
}
,
{
   page: 2,
   name: "Buyer 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 407.4,
   left: 108.12,
   width: 470.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Buyers 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 449.4,
   left: 108.36,
   width: 470.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Seller 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 491.4,
   left: 107.28,
   width: 470.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Seller 1 Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 529.44,
   left: 112.56,
   width: 465.00,
   height: 14.04
}
,
{
   page: 2,
   name: "Seller 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 544.2,
   left: 112.56,
   width: 170.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Seller 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 544.2,
   left: 407.04,
   width: 170.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Seller 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 559.32,
   left: 112.56,
   width: 465.00,
   height: 14.16
}
,
{
   page: 2,
   name: "Seller 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 582.12,
   left: 107.28,
   width: 470.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Seller 2 Address", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 620.28,
   left: 112.56,
   width: 465.00,
   height: 14.16
}
,
{
   page: 2,
   name: "Seller 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 635.16,
   left: 112.56,
   width: 170.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Seller 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 635.16,
   left: 407.04,
   width: 170.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Seller 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 650.16,
   left: 112.56,
   width: 465.00,
   height: 14.04
}
,
{
   page: 2,
   name: "Seller 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 673.08,
   left: 107.04,
   width: 470.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Seller 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 715.08,
   left: 107.04,
   width: 470.04,
   height: 14.16
}
,
{
   page: 2,
   name: "Additional Provisions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 54.673,
   left: 39.9274,
   width: 549.2746,
   height: 171.892
}
] }
